import { api } from "./api";
import type { LoginResponse, MeResponse } from "@/types/api";

export const authService = {
  login: async (phone: string, pin: string): Promise<LoginResponse> => {
    const { data } = await api.post<LoginResponse>("/auth/login", {
      phone,
      pin,
    });
    return data;
  },

  verifyOTP: async (otpToken: string, code: string): Promise<LoginResponse> => {
    const { data } = await api.post<LoginResponse>("/auth/verify-otp", {
      otp_token: otpToken,
      code,
    });
    return data;
  },

  me: async (): Promise<MeResponse> => {
    const { data } = await api.get<MeResponse>("/auth/me");
    return data;
  },

  changePIN: (currentPin: string, newPin: string) =>
    api
      .post<{ message: string; token?: string }>("/auth/change-pin", {
        current_pin: currentPin,
        new_pin: newPin,
      })
      .then((r) => r.data),
};
